import { Box, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import Iconify from "minimals-template/components/Iconify"

export function UnlockGroupDialog({ groupName = "" }) {
    return (
        <DialogBox
            title={
                <Box display="flex" alignItems="center" gap="12px" data-cy="unlock-group-dialog-title">
                    <Iconify icon="material-symbols:lock-open-outline" />
                    <Typography variant="h5">Unlock Group</Typography>
                </Box>
            }
            value={true}
            data-cy="unlock-group-dialog"
            okCaption="Unlock"
            okIcon="material-symbols:lock-open-outline"
        >
            <Typography mt={2}>
                This will make{" "}
                <Typography component="span" fontWeight={600}>
                    '{groupName}'
                </Typography>{" "}
                editable again.
            </Typography>
            <Typography mt={2}>
                Its previously applied changes will stay on the schedules until you re-apply the group.
            </Typography>
        </DialogBox>
    )
}
